import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const blockAnimatedTextClass = 'component-animated-text';
	const blockContainerElements = document.querySelectorAll(`.js-animated-text`);

	if (!blockContainerElements.length) {
		return;
	}

	const { AnimatedText } = await import('./animated-text');

	[...blockContainerElements].forEach((blockContainerElement) => {
		const animatedTextItems = blockContainerElement.querySelectorAll(`.${blockAnimatedTextClass}`);
		animatedTextItems.forEach((animatedTextItem) => {
			const animatedText = new AnimatedText({
				animatedTextItem,
			});
			animatedText.init();
		});
	});
});
